import { createSelector } from 'reselect';

import { languageSelector, gameGroupsSelector } from './config';

export const userSelector = (state) => state.user;

export const userRequestTimestampSelector = createSelector(
  userSelector,
  (user) => user?.requestTimestamp
);

export const userClientIdSelector = createSelector(
  userSelector,
  (user) => user?.client_id,
);

export const userTokenSelector = createSelector(
  userSelector,
  (user) => user?.token
);

export const userIdSelector = createSelector(
  userSelector,
  (user) => user?.uid
);

export const userOperatorIdSelector = createSelector(
  userSelector,
  (user) => user?.operatorId,
);

export const userBalanceSelector = createSelector(
  userSelector,
  (user) => user?.balance,
);

export const authParamsSelector = createSelector(
  userSelector,
  (user) => user?.authParams,
);

export const userCurrencySelector = createSelector(
  userSelector,
  (user) => user?.currency,
);

export const socketParamsSelector = createSelector(
  userSelector,
  languageSelector,
  (user, language) => ({
    ClientIP: user.client_ip,
    ClientId: user.client_id,
    GameID: 0,
    Language: language,
    MessageType: 'LobbyInitializeDataByHome',
    Nickname: user.nickname,
    OperatorId: user.operatorId,
    SessionCurrency: user.currency,
    UID: user.uid,
    clientType: 'html',
    currentPlayerToken: user.current_player_token,
  }),
);

/**
 * If `selectGame` is provided
 * Get the gameGroup id and start with that group selected
 */
export const selectGameGroupIdSelector = createSelector(
  gameGroupsSelector,
  authParamsSelector,
  (gameGroups, authParams) => {
    if (typeof authParams?.selectGame === 'undefined') {
      return null;
    }

    const activeGroup = Object.values(gameGroups).find((group) => {
      const sanitizedGroupSelectGame = group.selectGame
        ?.toString()
        .toLowerCase();
      const sanitizedSelectGame = authParams.selectGame
        .toString()
        .toLowerCase();

      return (
        // eslint-disable-next-line eqeqeq
        group.id == sanitizedSelectGame
        || sanitizedGroupSelectGame === sanitizedSelectGame
      );
    });

    return activeGroup ? activeGroup.id : null;
  },
);
